(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/draw-card/assets/javascripts/hooks/use-composed-draw-for-draw-card.js') >= 0) return;  svs.modules.push('/components/tipsen/draw-card/assets/javascripts/hooks/use-composed-draw-for-draw-card.js');
"use strict";


const _svs$components$tipse = svs.components.tipsen.drawCard.utils,
  getLeagueInfo = _svs$components$tipse.getLeagueInfo,
  composeTitle = _svs$components$tipse.composeTitle,
  useComposeBetEventsWithParticipants = _svs$components$tipse.useComposeBetEventsWithParticipants,
  getDrawState = _svs$components$tipse.getDrawState,
  getIconBySportType = _svs$components$tipse.getIconBySportType;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const useMemoizedSelector = svs.components.lbUtils.hooks.useMemoizedSelector;
const _svs$components$tipse2 = svs.components.tipsen.selectors,
  makeSelectLeaguesAccumulatedFromDraw = _svs$components$tipse2.makeSelectLeaguesAccumulatedFromDraw,
  makeSelectBetEventsFromDraw = _svs$components$tipse2.makeSelectBetEventsFromDraw;
const competitionHandler = svs.components.marketplaceCompetition.competitionHandler.competitionHandler;
const useComposeDrawForDrawCard = function () {
  let draw = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const betIndex = draw.betIndex,
    currentNetSale = draw.currentNetSale,
    description = draw.description,
    drawComment = draw.drawComment,
    drawNumber = draw.drawNumber,
    drawStateId = draw.drawStateId,
    productId = draw.productId,
    regCloseTime = draw.regCloseTime,
    sportType = draw.sportType;
  const state = getDrawState(draw);
  const drawId = "".concat(productId, "_").concat(drawNumber);
  const selectLeaguesCountFromDraw = useMemoizedSelector(makeSelectLeaguesAccumulatedFromDraw, drawId);
  const leaguesAccumulatedInOrder = useSelector(selectLeaguesCountFromDraw);
  const league = getLeagueInfo(leaguesAccumulatedInOrder);
  const title = composeTitle({
    drawComment,
    description,
    productId,
    betIndex,
    regCloseTime
  });
  const selectBetEventsFromDraw = useMemoizedSelector(makeSelectBetEventsFromDraw, drawId);
  const betEvents = useSelector(selectBetEventsFromDraw);
  const composedBetEvents = useComposeBetEventsWithParticipants(betEvents, drawId);
  const compHandler = competitionHandler();
  const activeCompetition = compHandler.getActiveCompetition(productId);
  let competitionName;
  let competitionDrawNumber = 0;
  if (activeCompetition) {
    var _activeCompetition$ge, _activeCompetition$ge2;
    const drawNumberList = (_activeCompetition$ge = (_activeCompetition$ge2 = activeCompetition.getData()) === null || _activeCompetition$ge2 === void 0 || (_activeCompetition$ge2 = _activeCompetition$ge2.details) === null || _activeCompetition$ge2 === void 0 ? void 0 : _activeCompetition$ge2.drawNumberList) !== null && _activeCompetition$ge !== void 0 ? _activeCompetition$ge : [];
    const isDrawIncludedInCompetition = drawNumberList.includes(drawNumber);
    if (isDrawIncludedInCompetition) {
      competitionDrawNumber = drawNumberList.indexOf(drawNumber) + 1;
    }
    competitionName = isDrawIncludedInCompetition ? activeCompetition.getCompetitionDesc() : undefined;
  }
  return {
    betEvents: composedBetEvents,
    competitionDrawNumber,
    drawNumber,
    drawStateId,
    extraMoney: draw.extraMoney,
    icon: competitionName ? 'trophy-tips-sm' : getIconBySportType(sportType),
    league,
    sportType,
    netSale: currentNetSale,
    productId,
    regCloseTime,
    competitionName,
    state,
    title,
    drawId: "".concat(productId, "_").concat(drawNumber)
  };
};
setGlobal('svs.components.tipsen.drawCard.useComposeDrawForDrawCard', useComposeDrawForDrawCard);

 })(window);